import { FC, ReactNode } from 'react';
import { render } from 'storyblok-rich-text-react-renderer-ts';

import PageSection from '../Layout/PageSection/PageSection';
import { RichTextLink } from '../RichTextLink';

const bold = (children: ReactNode) => (
  <strong className="font-bold">{children}</strong>
);

export const StaticText: FC<RichTextBlok> = ({ richText }) => (
  <PageSection>
    <div className="grid-section">
      <div className="col-span-12 md:col-span-8 md:col-start-3 lg:col-span-4 lg:col-start-5">
        <div className="aa-prose max-w-none">
          {render(richText, { markResolvers: { bold, link: RichTextLink } })}
        </div>
      </div>
    </div>
  </PageSection>
);
